import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { CreatePageRequest } from "@shopexperts/shared";

export function useCreatePage() {
  const api = useApi();
  const queryClient = useQueryClient();
  const toaster = useToaster();

  return useMutation({
    mutationFn: (data: CreatePageRequest) => 
      api.admin.pages.createPage({ body: data }),
    onSuccess: (_, variables) => {
      // Invalidate pages list for this schema
      if (variables.schema_id) {
        queryClient.invalidateQueries({ queryKey: ['admin', 'pages', { schema_id: variables.schema_id }] });
      }
      // Also invalidate general pages queries
      queryClient.invalidateQueries({ queryKey: ['admin', 'pages'] });
      // Invalidate schema to update pages_count
      queryClient.invalidateQueries({ queryKey: ['admin', 'page-schemas'] });
      
      toaster.create({
        title: "Page created successfully",
        type: "success",
      });
    },
    onError: (error: any) => {
      console.error('[useCreatePage] Error:', error);
      
      const errorMessage = 
        error?.response?.data?.message || 
        error?.response?.data?.error ||
        error?.message ||
        'An error occurred while creating the page.';
      
      toaster.create({
        title: "Failed to create page",
        description: errorMessage,
        type: "error",
      });
    },
  });
}
